import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, EstatisticasIncluir } from './types';

export const INITIAL_STATE: EstatisticasIncluir = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EstatisticasIncluir {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ESTATISTICA_INCLUIR_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.ESTATISTICA_INCLUIR_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = 200;
				break;
			}

			case Types.ESTATISTICA_INCLUIR_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ESTATISTICA_INCLUIR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
